export default __webpack_public_path__ + "bcc7e14278c210a528e0b105f5b3745a.svg";